var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-block"}},[_vm._t("default"),_c('ConfirmDialog',{attrs:{"dialogShow":_vm.dialogShow,"title":"审批通过","showFooter":true,"width":800},on:{"updateDialogShow":_vm.updateDialogShow,"confirm":_vm.confirm}},[_vm._v(" 请确认是否审批通过 ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }